import React from 'react'
import styles from './ExperiencesLookup.scss'
import {AdminLayout} from '../layoutComponents'
import {SearchableCardMulti, SearchableCardInput} from 'common/SearchableCardMulti'
import {Card} from 'common/styleguide/Card'
import {CircleSpinner} from 'common/spinners/CircleSpinner'
import fetchJSON from 'lib/fetchJSON'
import cx from 'classnames'

export class ExperiencesLookup extends React.PureComponent {
  state = {
    code: '',
    loading: false,
    results: null,
    errors: null
  }

  onSubmit = (e) => {
    e.preventDefault()
    const {code} = this.state
    this.setState({loading: true, errors: null})
    fetchJSON(`/admin/experiences/lookup.json?apikey=x&version=3&code=${code}`)
      .then(results => this.setState({loading: false, errors: null, results}))
      .catch(response => {
        this.setState({errors: response.errors, loading: false})
      })
  }

  render () {
    const {loading, results, code, errors} = this.state

    const input = (
      <form style={{flex: 1}} onSubmit={this.onSubmit}>
        <SearchableCardInput
          type='text'
          placeholder='Search by app code'
          keywords={code}
          onKeywordChange={e => this.setState({code: e.target.value.toUpperCase().trim()})} />
      </form>
    )

    const getClubName = (clubId) => (
      results.extras.find(e => e.type === 'club' && e.id === clubId).club.name
    )

    return (
      <AdminLayout readonly narrow title='Experiences Lookup'>
        <div className={styles.ExperiencesLookup}>
          <Card noPadding>
            <SearchableCardMulti inputs={[input]}>
              {!loading && !errors && !results && <div style={{padding: '120px 0', textAlign: 'center'}}>
                No results
              </div>}
              {loading && <div style={{padding: '120px 0', textAlign: 'center'}}>
                <CircleSpinner size={25} />
              </div>}
              {errors && errors.map((e, i) => (
                <div className={styles.error} key={i}>{e.error_code} - {e.error_message}</div>
              ))}
              {!loading && !errors && results && <div className={styles.result}>
                <div className={styles.headLite}>Found Experience:</div>
                <h3><a href={`/experiences/${results.experience.id}/edit`}>{results.experience.name}</a></h3>
                <div className={styles.headLite}>Account:</div>
                <a href={`/organizations/${results.experience.club_id}`}>{getClubName(results.experience.club_id)}</a>
                <div className={styles.headLite}>Shortcodes:</div>
                {results.extras.filter(e => e.type === 'app_code').map((c) => (
                  <div key={code.id} className={cx(styles.code, c.app_code.active && styles.highlightedCode)}>
                    {c.app_code.code} - {c.app_code.active ? 'active' : 'inactive'}
                  </div>
                ))}
              </div>}
            </SearchableCardMulti>
          </Card>
        </div>
      </AdminLayout>
    )
  }
}
